import { lazy } from 'react';

// ** Document title
const TemplateTitle = '%s - Admin';

// ** Default Route
const DefaultRoute = '/home';

// ** Merge Routes
const Routes = [];

export { DefaultRoute, TemplateTitle, Routes };
